import React, {useEffect, useCallback, useState, useRef} from 'react';

import * as Yup from 'yup';
import { useToasts } from 'react-toast-notifications'
import { useParams, useHistory } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';


// core components
import styles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import TextField from '@material-ui/core/TextField';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import FileUploader from 'components/FileUploader/FileUploader';

import api from '../../services/api';
import getValidationErrors from '../../utils/getValidationErrors';

const useStyles = makeStyles(styles);

export default function EditScent() {
  const [action, setAction] = useState('create');
  const [name, setName] = useState('');
  const [type, setType] = useState('');

  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedFile, setSelectedFile] = useState('');
  const [imagem, setImagem] = useState('');
  const [removerImagem, setRemoverImagem] = useState(false);
  const formRef = useRef(null);
  const history = useHistory();
  const { addToast } = useToasts()

  const { id } = useParams();   
  const classes = useStyles();

  useEffect(() => {
    if (id != "new"){
      setAction("update");
    }
  },[]);

  useEffect(() => {
    if (action === "update"){
      loadData(id);
    }
  },[action]);


  const handleSave = (async (e) => {

    try { 

      e.preventDefault();

      const name = e.target.name.value;
      const type = e.target.type.value;
      const description = e.target.description.value;

      const schema = Yup.object().shape({
        name: Yup.string().required('Nome é obrigatório !'),              
      });         

      await schema.validate({name, type, description}, {
        abortEarly: false,
      });

    
      const formData = new FormData();
      formData.append('name', name);
      formData.append('description', description);
      formData.append('type', type);

      if (selectedFile){
        formData.append('photo', selectedFile);
      }
 
      if (action === 'update'){
        await api.put(`/scent/${id}`, formData);
      }
      else{
        await api.post(`/scent`, formData);
      }

      history.push('/admin/scents');
   
    }
    catch(e){ 

      if (e instanceof Yup.ValidationError) {
        const errors = getValidationErrors(e); 

        for (var [, value] of Object.entries(errors)) {
          addToast(value, {
            appearance: 'error',
            autoDismiss: true,
          });
        }
        return;
      }    
       
      addToast(e.response ? e.response.data.message : 'Ocorreu um erro !', {
        appearance: 'error',
        autoDismiss: true,
      });
             
    }
  }); 
  

  const loadData = useCallback(async () => {    
    try {
      const response = await api.get(`/scent/${id}`);
      setName(response.data.name);
      setDescription(response.data.description);    
      setType(response.data.type);
      setImagem(response.data.photo);
    }
    catch(e){

      addToast(e.response.data.message ? e.response.data.message : 'Ocorreu um erro !', {
        appearance: 'error',
        autoDismiss: true,
      });       
      
      history.push("/admin/scents");
      
    }
  
  });


  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <form className={classes.form} ref={formRef} onSubmit={handleSave}>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Dados do Aroma</h4>
              <p className={classes.cardCategoryWhite}>Complete os dados.</p>
            </CardHeader>
            <CardBody>
           
            {!loading && <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="name"
                      label="Nome"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      autoFocus
                  />  
            
                  <FormControl fullWidth variant="outlined" className={classes.formControl} style={{ marginTop: 10}}>
                      <InputLabel id="type">Destino</InputLabel>
                      <Select
                        labelId="type"
                        label="destino"
                        variant="outlined"
                        name="type"
                        fullWidth
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      >
                        <MenuItem key="topo" value="topo">Topo</MenuItem>
                        <MenuItem key="meio" value="meio">Meio</MenuItem>
                        <MenuItem key="base" value="base">Base</MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      variant="outlined"
                      margin="normal"                     
                      multiline={true}
                      rows={10}
                      fullWidth
                      id="description"
                      label="Descrição"
                      name="description"                     
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
           
                   />  

                  <br />

                  <FileUploader
                    onFileSelectSuccess={(file) => { 
                       setSelectedFile(file);                     
                       setImagem(null); 
                       setRemoverImagem(false);
                    }}
                    onFileSelectError={({ error }) => addToast(error, {
                      appearance: 'error',
                      autoDismiss: true,
                    })}
                 />

                  {imagem ?
                  <>     
                    <hr />
                       <img src={`${process.env.REACT_APP_IMAGENS_URL_PREFIX}/scent/rs/${imagem}`} height="250" />       
                    <hr />
                  </> : null}


                </GridItem>               
              </GridContainer>}
             
            </CardBody>
            <CardFooter>
              <Button color="primary" type="submit">Salvar</Button>
            </CardFooter>
          </form>
          </Card>
        </GridItem>
        
      </GridContainer>
    </div>
  );
}
